<template>
  <dialog id="language-dialog" ref="dialog" aria-labelledby="language-title" @click.self="close" @close="$emit('close')">
    <div class="language-dialog-head">
      <div>
        <span class="language-kicker">VERVESTEEL · GLOBAL</span>
        <h2 id="language-title">{{ $t('language.title') }}</h2>
      </div>
      <button id="language-close" type="button" :aria-label="$t('language.close')" @click="close">×</button>
    </div>
    <p class="language-help">{{ $t('language.help') }}</p>
    <div class="language-options">
      <button
        v-for="language in languages"
        :key="language.code"
        class="language-option"
        :class="{ selected: language.code === $i18n.locale }"
        type="button"
        :aria-pressed="String(language.code === $i18n.locale)"
        @click="select(language.code)"
      >
        <strong>{{ language.native }}</strong>
        <span>{{ language.english }}</span>
        <small>{{ language.code === $i18n.locale ? $t('language.current') : $t('language.available') }}</small>
      </button>
    </div>
    <p class="language-footnote">{{ $t('language.pdf') }}</p>
  </dialog>
</template>

<script>
import { setLocale, supportedLocales } from '../i18n'

export default {
  name: 'LanguageDialog',
  data() {
    return { languages: supportedLocales }
  },
  methods: {
    open() {
      this.$refs.dialog.showModal()
    },
    close() {
      this.$refs.dialog.close()
    },
    select(locale) {
      setLocale(locale)
      this.$emit('change', locale)
      this.close()
    }
  }
}
</script>
